import { useQuery } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const QUERY = graphql(`
  query topBanners($companyId: ID!) {
    topBanners(companyId: $companyId) {
      ...TopBannerItem
    }
  }
`);

export function useTopBanners(companyId: string) {
  return useQuery(QUERY, {
    variables: {
      companyId,
    },
  });
}
